import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {take} from "rxjs";
import {BackOfficeConfig} from "../interfaces/back-office-config";
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  targetStorage: string = '';
  backofficeConfig: BackOfficeConfig = {} as BackOfficeConfig;

  constructor(private http: HttpClient, private configService: ConfigService) {
  }

  initializeAssets(): Promise<boolean> {
      this.backofficeConfig = this.configService.getBackOfficeConfig();
      this.targetStorage = this.backofficeConfig['FLEET_ASSETS_TARGET_ON_LOCAL_STORAGE'];
      switch (this.backofficeConfig['TRANSLATION_SOURCE']) {
        case 'LOCAL':
          return this.initializeLocalAssets()
        case 'BUCKET':
          return this.initializeBucketAssets()
        case 'BACKOFFICE':
          return this.initializeBackOfficeAssets(this.backofficeConfig)
        default:
          return new Promise<boolean>((resolve) => {
            resolve(false)
          });
      }
  }

  initializeLocalAssets(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.http.get(`http://localhost:3000/getAssets`).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value))
      });
      resolve(true);
    });
  }

  initializeBucketAssets(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE;
      this.http.get(`/fakeoffice/asset_map/asset_map.json`).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value))
      });
      resolve(true);
    });
  }

  initializeBackOfficeAssets(backofficeConfig: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      resolve(true)
    });
  }

  getAsset(assetName: string): string {
    const assetList = localStorage.getItem(this.targetStorage);
    if (!assetList) return '';
    const parsedList = JSON.parse(assetList);
    if ( !parsedList['assetList']) return '';
    const getValueByKey = (obj: Record<string, any>, key: string): string =>
      obj.hasOwnProperty(key) ? obj[key] : '';

    console.log(assetName, getValueByKey(parsedList['assetList'], assetName))

    return getValueByKey(parsedList['assetList'], assetName);
  }
}
